import React from 'react'
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  IconButton,
} from '@material-ui/core'
import { ExpandMore, DragIndicator, Group, MoreVert } from '@material-ui/icons'
import classNames from 'classnames'

export default ({ idx, stage, classes, style }) => (
  <div style={{ transform: 'translate(0, 0)', ...style, opacity: '0.7' }}>
    <ExpansionPanel
      expanded={false}
      classes={{
        root: classes.expansionPanelRoot,
        expanded: classes.expansionPanelExpanded,
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: 14,
          width: 2,
          height: 'calc(100% - 50px)',
          backgroundColor: '#034c94',
          display: 'block',
        }}
      />
      <ExpansionPanelSummary
        classes={{
          root: classes.summaryRoot,
          expanded: classes.summaryExpanded,
          content: classes.content,
          expandIcon: classNames(
            classes[`expandIcon${idx}`],
            classes.expandIconMore,
          ),
        }}
        expandIcon={<ExpandMore style={{ color: '#fff' }} />}
      >
        <div
          style={{
            width: '100%',
            paddingLeft: 48,
            paddingRight: 0,
          }}
        >
          <div
            className={classNames(
              classes.numberIcon,
              classes[`backgroundColor${idx}`],
              classes.backgroundColorMore,
              classes.numberIconCollapsed,
            )}
          >
            {parseInt(idx) + 1}
          </div>
          <div
            style={{
              borderStyle: 'solid',
              borderWidth: 2,
              borderBottomWidth: 0,
              borderColor: 'transparent',
            }}
            className={classNames(
              classes.background,
              classes[`backgroundColor${idx}`],
              classes[`backgroundWidth${idx}`],
              classes.backgroundColorMore,
              classes.backgroundWidthMore,
              classes.backgroundCollapsed,
            )}
          >
            <DragIndicator
              style={{
                position: 'absolute',
                left: 5,
                top: 10,
                fill: 'rgba(255, 255, 255, 0.5)',
                cursor: 'grab',
              }}
            />
            <input
              className={classNames(classes.heading)}
              value={stage.name}
              onClick={e => e.stopPropagation()}
            />
            <IconButton
              disableRipple
              disableTouchRipple
              style={{
                position: 'absolute',
                right: 103,
                top: 6,
                color: '#fff',
                padding: 6,
              }}
            >
              <MoreVert />
            </IconButton>
            <div
              style={{
                position: 'absolute',
                color: '#fff',
                right: 50,
                top: 15,
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              <div style={{ position: 'relative' }}>
                <Group
                  style={{
                    position: 'absolute',
                    left: '-30px',
                    top: '-3px',
                  }}
                />
                {stage.event_goals
                  ? stage.event_goals
                      .reduce((contactSum, event_goal) => {
                        if (event_goal.count) {
                          contactSum += event_goal.count
                        }
                        return contactSum
                      }, 0)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : '0'}
              </div>
            </div>
          </div>
        </div>
      </ExpansionPanelSummary>
    </ExpansionPanel>
  </div>
)
